"use strict";import{Switch as e}from"./src/Switch.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-switch",e);
//# sourceMappingURL=sp-switch.js.map
